import React from 'react';
import {ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {fetchBidderStatuses} from '~/modules/Bidders/api';

type ISelectBidderStatusProps = Omit<ISelectProps<string>, 'items'>;

export const SelectBidderStatus = ({
    disabled,
    ...props
}: ISelectBidderStatusProps) => {
    const {resource, isPending} = useResource(() => fetchBidderStatuses(), []);
    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={resource.map(status => ({
            label: status,
            value: status
        }))}/>;
};

export const SelectBidderStatusField = (props: IFieldProps<ISelectBidderStatusProps>) => <FormField {...props}>
    <SelectBidderStatus {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
